(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-contact-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Brochure modal. Moved to <body> on first open so no ancestor stacking context can trap it,
     which is what the previous inline version on this page did. */
  function close(m){m.hidden=true;document.documentElement.style.overflow='';}
  document.addEventListener('click',function(e){
    var open=e.target.closest&&e.target.closest('[data-cc-open]');
    if(open){
      var m=document.querySelector('[data-cc-modal="'+open.getAttribute('data-cc-open')+'"]');
      if(!m)return;
      if(m.parentNode!==document.body)document.body.appendChild(m);
      m.hidden=false;m.scrollTop=0;document.documentElement.style.overflow='hidden';
      return;
    }
    var cl=e.target.closest&&e.target.closest('[data-cc-close]');
    if(cl){var m2=document.querySelector('[data-cc-modal="'+cl.getAttribute('data-cc-close')+'"]');if(m2)close(m2);return;}
    if(e.target.hasAttribute&&e.target.hasAttribute('data-cc-modal'))close(e.target);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    document.querySelectorAll('[data-cc-modal]').forEach(function(m){if(!m.hidden)close(m);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-contact-hero-form"] && !Shopify.designMode) return;
  try {
    
(function(){
  function isEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}

  /* Hardcoded, NOT a theme setting. Shopify compiles this javascript block into a shared static
     asset WITHOUT evaluating Liquid, so a Liquid tag here would ship verbatim and break the whole
     compiled bundle for every section on the site. Never put Liquid in this block.
     Form 82271 is the contact page form, the same one sections/cp-product-enquiry.liquid posts to. */
  var GLOBO_FORM_ID='82271';
  var GLOBO_URL='https://app.powerfulform.com/api/front/form/'+GLOBO_FORM_ID+'/send';
  /* Globo prints these labels in the notification email. Without _keyLabel the info@ email arrives
     labelled text-1 / phone-1 / textarea, or empty. Verified 2026-09-17. */
  var GLOBO_LABELS={'text-1':'Name','email':'Email','phone-1':'Phone','country-1':'Country','text-2':'City','select-1':'Product/Service','textarea':'Message','hidden-1':'cp_attr'};

  function visitorId(){
    try{
      var k='globo-visitor-id',v=localStorage.getItem(k);
      if(!v){
        v=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0;return (c==='x'?r:(r&3|8)).toString(16);});
        localStorage.setItem(k,v);
      }
      return v;
    }catch(e){return '';}
  }

  function initForm(form){
    if(form.dataset.cfInit)return;form.dataset.cfInit='1';

    function fieldVal(n){var el=form.querySelector('[name="'+n+'"]');return el?String(el.value||'').trim():'';}

    function validate(el){
      var f=el.closest('.cf-field');if(!f)return true;
      var ok=true;
      if(el.hasAttribute('required'))ok=el.value.trim()!=='';
      if(ok&&el.type==='email')ok=isEmail(el.value.trim());
      f.classList.toggle('err',!ok);
      return ok;
    }
    form.querySelectorAll('input,select,textarea').forEach(function(el){
      el.addEventListener('blur',function(){validate(el);});
      el.addEventListener('input',function(){var f=el.closest('.cf-field');if(f&&f.classList.contains('err'))validate(el);});
    });

    /* Globo payload. select-1 is the only routing field 82271 has, so the chosen topic maps onto it
       (each chip carries its own data-product), and an explicitly chosen Model wins over the chip
       default. The topic is ALSO written into the message, so whatever the visitor picked survives
       even if the dropdown options change in Globo later. */
    function globoPayload(){
      var fd=new FormData();
      var topic=fieldVal('topic');
      var product=fieldVal('product');
      if(!product && /rental/i.test(topic)) product='Business/Rental';
      var msg=fieldVal('message');
      /* Message is required on the Globo side, so it is never sent empty. */
      if(!msg)msg='Enquiry from the contact page.';
      if(topic)msg='Enquire about: '+topic+'\n\n'+msg;
      var ph=fieldVal('phone'),cc=fieldVal('ccode');
      fd.append('text-1',fieldVal('name'));
      fd.append('email',fieldVal('email'));
      fd.append('phone-1',ph?((cc?cc+' ':'')+ph):'');
      fd.append('country-1',fieldVal('country'));
      fd.append('text-2',fieldVal('city'));
      fd.append('select-1',product);
      fd.append('textarea',msg);
      /* Ad attribution: the intake's Add Ad Tracking node reads cp_attr, and 82271 has hidden-1 for
         it. page[href] keeps its query string, which carries gclid, utm_* and gad_*. */
      var cpv='';
      try{
        var cpm=document.cookie.match(/(?:^|;\s*)cp_attr=([^;]+)/);
        if(cpm){cpv=decodeURIComponent(cpm[1]);if(cpv==='{}')cpv='';}
      }catch(e){}
      fd.append('hidden-1',cpv);
      fd.append('page[title]',document.title);
      fd.append('page[href]',window.location.href);
      fd.append('_keyLabel',JSON.stringify(GLOBO_LABELS));
      fd.append('locale',(window.Shopify&&Shopify.locale)||'en');
      try{fd.append('time_zone',Intl.DateTimeFormat().resolvedOptions().timeZone);}catch(e){}
      return fd;
    }

    var submitBtn=form.querySelector('[type="submit"]');
    var sending=false;
    function clearSendError(){var e=form.querySelector('[data-send-error]');if(e)e.remove();}
    function showSendError(){
      clearSendError();
      var d=document.createElement('p');
      d.setAttribute('data-send-error','');
      /* Styled inline so the message never depends on the stylesheet block compiling. */
      d.setAttribute('style','margin:12px 0 0;padding:11px 13px;border:1px solid #e6b0b0;background:#fdf3f3;border-radius:6px;font-size:13px;line-height:1.5;color:#8a2b2b');
      d.innerHTML='Sorry, we could not send that just now. Please try again, or email <a href="mailto:info@coolperformance.com" style="color:inherit;font-weight:600">info@coolperformance.com</a> and we will pick it up right away.';
      var act=form.querySelector('.cf-actions');
      if(act&&act.parentNode)act.parentNode.insertBefore(d,act.nextSibling);else form.appendChild(d);
      d.scrollIntoView({block:'nearest',behavior:'smooth'});
    }

    form.addEventListener('submit',function(e){
      e.preventDefault();
      var firstBad=null;
      [].slice.call(form.querySelectorAll('[required]')).forEach(function(el){if(!validate(el)&&!firstBad)firstBad=el;});
      if(firstBad){firstBad.focus();return;}
      if(sending)return;
      sending=true;
      var btnHTML=submitBtn?submitBtn.innerHTML:'';
      if(submitBtn){submitBtn.disabled=true;submitBtn.textContent='Sending…';}
      clearSendError();
      fetch(GLOBO_URL,{method:'POST',body:globoPayload(),headers:{'X-Visitor-Id':visitorId()}})
        .then(function(r){return r.json();})
        .then(function(d){
          if(!d||String(d.success)!=='true')throw new Error((d&&d.msg)||'Submission rejected');
          window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'lead_form_submit',form_id:GLOBO_FORM_ID});
          /* class="success" is what the GTM lead trigger (Element Visibility, CSS .success) watches,
             the same as Globo's own thank-you panel. Keep it. */
          var done=form.getAttribute('data-done-html')||'';
          form.innerHTML='<div class="success" style="text-align:center;padding:26px 6px 10px">'+done+'</div>';
        })
        .catch(function(){
          /* Never swallow the enquiry: keep what the visitor typed on screen, let them retry,
             and give them a direct way through. */
          sending=false;
          if(submitBtn){submitBtn.disabled=false;submitBtn.innerHTML=btnHTML;}
          showSendError();
        });
    });
  }

  function boot(){document.querySelectorAll('[data-cp-contact-form]').forEach(initForm);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-contact-routes"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Card taps never leave the page: scroll to the form in the hero and preselect the matching topic
     chip, so step 2 is already answered when the visitor gets there. */
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-cp-topic]');
    if(!b)return;
    var form=document.querySelector('[data-cp-contact-form]');
    if(!form)return;
    var wanted=b.getAttribute('data-cp-topic')||'';
    if(wanted){
      var radios=form.querySelectorAll('[name="topic"]');
      [].slice.call(radios).forEach(function(r){
        if(r.value.toLowerCase()===wanted.toLowerCase()){r.checked=true;}
      });
    }
    form.scrollIntoView({block:'start',behavior:'smooth'});
    var first=form.querySelector('input[name="name"]');
    if(first)setTimeout(function(){first.focus({preventScroll:true});},450);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('.f1-arch__track').forEach(function (track) {
      if (track.dataset.init) return;
      track.dataset.init = '1';
      var slider = track.closest('.f1-arch__slider');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Lazy video activation (unchanged): observe the existing <video> nodes.
         Recycling only reorders their <li> ancestors, so these element refs stay
         observed and the one-time src load guard (data-loaded) still holds. */
      var vids = track.querySelectorAll('.f1-arch__video[data-vsrc]');
      if (vids.length) {
        /* Two observers, deliberately different jobs.
         PRELOAD: a wide horizontal margin (~2 card widths) so the poster and the video source are
         fetched for the current card and roughly the next two, ready before they are swiped to.
         PLAY: no margin and a real visibility threshold, so only cards actually on screen play.
         Previously one observer with rootMargin 250px did both, which meant every card within
         250px was playing at once: several decoders running for slides nobody is looking at. */
      function preload(v) {
        var ps = v.getAttribute('data-poster');
        if (ps && !v.poster) { v.poster = ps; }
        if (!v.dataset.loaded) { v.src = v.getAttribute('data-vsrc'); v.load(); v.dataset.loaded = '1'; }
      }
      function activate(v) {
        preload(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var preIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) preload(en.target); });
        }, { rootMargin: '200px 850px', threshold: 0 });

        var playIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) activate(en.target);
            else if (en.target.dataset.loaded) { try { en.target.pause(); } catch (e) {} }
          });
        }, { rootMargin: '0px', threshold: 0.55 });

        vids.forEach(function (v) { preIO.observe(v); playIO.observe(v); });
      } else { vids.forEach(activate); }
      }

      /* Infinite, bidirectional loop by SINGLE-CARD RECYCLING.
         DOM node count always == number of real cards (no clones, no 3x set).
         When the scroll approaches an edge we relocate the one off-screen card
         from that end to the other end and compensate scrollLeft by exactly one
         card width, so the move is invisible and there is always more track to
         scroll into on both sides. Works for touch/drag, wheel and the buttons. */
      var W = 0; /* one card + gap, px */
      function measure() {
        var card = track.firstElementChild;
        if (!card) { W = 0; return; }
        var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
        W = card.getBoundingClientRect().width + gap;
      }
      function overflow() { return track.scrollWidth - track.clientWidth; }
      function loopable() { return track.children.length > 2 && overflow() > W + 1; }
      /* Relocating a card in the DOM force-pauses any <video> inside it, and the
         IntersectionObserver only fires on intersection CHANGES, so a still-visible
         moved card would freeze. Resume loaded videos on every recycle; the observer
         still pauses the genuinely off-screen ones. */
      function resumeVids(card) {
        if (!card) return;
        card.querySelectorAll('.f1-arch__video[data-loaded]').forEach(function (v) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        });
      }
      function moveFirstToEnd() { var c = track.firstElementChild; track.appendChild(c); track.scrollLeft -= W; resumeVids(c); }
      function moveLastToFront() { var c = track.lastElementChild; track.insertBefore(c, track.firstElementChild); track.scrollLeft += W; resumeVids(c); }

      var lock = false, settleTimer = null, ticking = false;

      function recycle() {
        if (!W) return;
        if (track.scrollLeft < W) moveLastToFront();
        else if (track.scrollLeft > overflow() - W) moveFirstToEnd();
      }

      /* Native drag / wheel / momentum: recycle live on scroll (rAF-throttled).
         Suppressed while a button-driven programmatic scroll runs (lock). */
      track.addEventListener('scroll', function () {
        if (lock || ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; if (!lock) recycle(); });
      }, { passive: true });

      function scheduleUnlock() {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () { lock = false; recycle(); }, 240);
      }

      function go(dir) {
        measure();
        if (!loopable()) {
          /* Too few cards to overflow: wrap to the far end so it still never dead-ends. */
          var max = overflow();
          var mode = reduce ? 'auto' : 'smooth';
          if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: mode });
          else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior: mode });
          else track.scrollBy({ left: W * dir, behavior: mode });
          return;
        }
        lock = true;
        /* Pre-recycle one off-screen card toward the travel direction so the
           smooth scroll always has a full card of room and never hits the
           physical edge (the move is compensated, hence invisible). */
        if (dir > 0) moveFirstToEnd(); else moveLastToFront();
        if (reduce) { track.scrollLeft += W * dir; lock = false; recycle(); }
        else { track.scrollBy({ left: W * dir, behavior: 'smooth' }); scheduleUnlock(); }
      }

      if (slider) {
        slider.querySelectorAll('.f1-arch__nav').forEach(function (btn) {
          btn.addEventListener('click', function () {
            go(parseInt(btn.getAttribute('data-dir'), 10) || 1);
          });
        });
      }

      /* Seed a one-card buffer on the left so "prev" from the very start wraps
         seamlessly: park the last card off-screen left, card 1 sits at the edge. */
      function setup() {
        measure();
        if (loopable()) { track.scrollLeft = 0; moveLastToFront(); }
      }
      requestAnimationFrame(setup);

      var resizeT;
      window.addEventListener('resize', function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () { measure(); if (loopable() && track.scrollLeft < 1) moveLastToFront(); }, 200);
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-branding-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(slider){
    if(!slider||slider.dataset.baInit)return;slider.dataset.baInit='1';
    var dragging=false;
    var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    var wrap=slider.closest('.f1-branding-gallery__wrap')||document;
    var beforeImg=slider.querySelector('.ba-before');
    var afterImg=slider.querySelector('.ba-img:not(.ba-before)');
    var labelAfter=slider.querySelector('.ba-label-after');
    var handle=slider.querySelector('.ba-handle');
    var tStartX=0,tStartY=0,touchPending=false,touchDragging=false;
    function xOf(e){return (e.touches&&e.touches[0])?e.touches[0].clientX:e.clientX;}
    function yOf(e){return (e.touches&&e.touches[0])?e.touches[0].clientY:e.clientY;}
    function setPos(p){p=Math.max(0,Math.min(100,p));slider.style.setProperty('--pos',p+'%');if(handle)handle.setAttribute('aria-valuenow',Math.round(p));}
    function set(cx){var r=slider.getBoundingClientRect();if(!r.width)return;setPos(((cx-r.left)/r.width)*100);}
    // mouse / pen drag (pointer events) — behaviour unchanged. Touch is handled separately below.
    function down(e){if(e.pointerType&&e.pointerType==='touch')return;dragging=true;slider.classList.add('is-dragging');set(xOf(e));document.addEventListener('pointermove',move,{passive:false});if(e.cancelable)e.preventDefault();}
    function move(e){if(e.pointerType&&e.pointerType==='touch')return;if(!dragging)return;set(xOf(e));if(e.cancelable)e.preventDefault();}
    function up(){dragging=false;slider.classList.remove('is-dragging');document.removeEventListener('pointermove',move);}
    // touch drag — never preventDefault on touchstart. Only engage the slider once a touchmove
    // shows the gesture is predominantly horizontal, so a vertical swipe scrolls the page through.
    function tdown(e){touchPending=true;touchDragging=false;tStartX=xOf(e);tStartY=yOf(e);document.addEventListener('touchmove',tmove,{passive:false});}
    function tmove(e){
      if(!touchPending&&!touchDragging)return;
      var dx=xOf(e)-tStartX,dy=yOf(e)-tStartY;
      if(!touchDragging){
        if(Math.abs(dx)<6&&Math.abs(dy)<6)return;
        if(Math.abs(dx)>Math.abs(dy)){touchDragging=true;dragging=true;slider.classList.add('is-dragging');}
        else{touchPending=false;return;}// vertical: let the page scroll
      }
      set(xOf(e));if(e.cancelable)e.preventDefault();
    }
    function tup(){touchPending=false;touchDragging=false;dragging=false;slider.classList.remove('is-dragging');document.removeEventListener('touchmove',tmove);}
    slider.addEventListener('pointerdown',down);
    slider.addEventListener('touchstart',tdown,{passive:true});
    document.addEventListener('pointerup',up);
    document.addEventListener('pointercancel',up);
    document.addEventListener('touchend',tup);
    document.addEventListener('touchcancel',tup);

    // keyboard control: arrow keys move the reveal, Home/End jump to edges
    if(handle){
      handle.addEventListener('keydown',function(e){
        var cur=parseFloat(slider.style.getPropertyValue('--pos'));
        if(isNaN(cur))cur=50;
        var step=e.shiftKey?10:2,np=cur;
        switch(e.key){
          case 'ArrowLeft':case 'ArrowDown':np=cur-step;break;
          case 'ArrowRight':case 'ArrowUp':np=cur+step;break;
          case 'Home':np=0;break;
          case 'End':np=100;break;
          default:return;
        }
        e.preventDefault();
        sweepToken++;// cancel any running intro sweep so it can't fight keyboard input
        setPos(np);
      });
    }

    // intro sweep, re-runnable from the start (latest call wins)
    var sweepToken=0;
    function sweep(){
      var my=++sweepToken;
      setPos(50);
      var keys=[[50,0],[82,650],[18,1450],[50,2200]];
      var start=null;
      function ease(t){return t<.5?2*t*t:(4-2*t)*t-1;}
      function frame(ts){
        if(dragging||my!==sweepToken)return;
        if(start===null)start=ts;
        var el=ts-start,i=0;
        while(i<keys.length-1&&el>keys[i+1][1])i++;
        if(i>=keys.length-1){slider.style.setProperty('--pos','50%');return;}
        var a=keys[i],b=keys[i+1],f=(el-a[1])/(b[1]-a[1]);f=f<0?0:f>1?1:f;
        slider.style.setProperty('--pos',(a[0]+(b[0]-a[0])*ease(f))+'%');
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    // thumbnail switcher: swap before/after src, update active state, restart sweep
    var thumbs=wrap.querySelector('.ba-thumbs');
    if(thumbs){
      thumbs.addEventListener('click',function(e){
        var btn=e.target.closest('.ba-thumb');
        if(!btn||!thumbs.contains(btn))return;
        var b=btn.getAttribute('data-before'),a=btn.getAttribute('data-after'),la=btn.getAttribute('data-label-after');
        if(beforeImg&&b&&beforeImg.getAttribute('src')!==b)beforeImg.src=b;
        if(afterImg&&a)afterImg.src=a;
        if(labelAfter&&la)labelAfter.textContent=la;
        thumbs.querySelectorAll('.ba-thumb').forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-pressed','false');});
        btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');
        setPos(50);
        if(!reduce)sweep();
      });
    }

    // intro sweep once, when scrolled into view
    if('IntersectionObserver' in window && !reduce){
      var swept=false;
      var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting&&!swept){swept=true;io.disconnect();sweep();}});},{threshold:.35});
      io.observe(slider);
    }
  }
  function run(root){(root||document).querySelectorAll('.f1-branding-gallery .cb-ba').forEach(init);}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',function(){run();});}
  document.addEventListener('shopify:section:load',function(e){run(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-contact-fab"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root||document).querySelectorAll('[data-f1-fab]').forEach(function(fab){
      if(fab.__f1Init)return; fab.__f1Init=true;
      var toggle=fab.querySelector('[data-f1-fab-toggle]');
      var menu=fab.querySelector('[data-f1-fab-menu]');
      var dismiss=fab.querySelector('[data-f1-fab-dismiss]');
      function setOpen(open){
        fab.setAttribute('data-open',open?'true':'false');
        toggle.setAttribute('aria-expanded',open?'true':'false');
        if(open){menu.hidden=false;}else{setTimeout(function(){if(fab.getAttribute('data-open')!=='true')menu.hidden=true;},250);}
      }
      function setTucked(t){fab.setAttribute('data-tucked',t?'true':'false');if(t)setOpen(false);try{localStorage.setItem('f1FabTucked',t?'1':'0');}catch(e){}}
      try{if(localStorage.getItem('f1FabTucked')==='1')fab.setAttribute('data-tucked','true');}catch(e){}
      toggle.addEventListener('click',function(e){
        e.stopPropagation();
        if(fab.getAttribute('data-tucked')==='true'){setTucked(false);return;}
        setOpen(fab.getAttribute('data-open')!=='true');
      });
      if(dismiss)dismiss.addEventListener('click',function(e){e.stopPropagation();setTucked(true);});
      document.addEventListener('click',function(e){if(!fab.contains(e.target))setOpen(false);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')setOpen(false);});

      // hide over the hero; reveal once scrolled past it
      var hero=document.querySelector('.f1-hero, #top');
      function reveal(v){fab.setAttribute('data-revealed',v?'true':'false');if(!v)setOpen(false);}
      if(hero&&'IntersectionObserver' in window){
        new IntersectionObserver(function(es){es.forEach(function(en){reveal(!en.isIntersecting);});},{threshold:0}).observe(hero);
      }else{
        var onScroll=function(){reveal((window.scrollY||window.pageYOffset||0)>600);};
        onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
      }
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init();});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-event-types"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (!section || section.dataset.etReady) return;
    var id = section.getAttribute('data-et-root');
    var modal = section.querySelector('[data-et-modal]') || document.querySelector('[data-et-modal="' + id + '"]');
    if (!modal) return;
    section.dataset.etReady = '1';

    // portal the modal to <body> so backdrop-filter blur isn't broken by an ancestor
    document.querySelectorAll('body > [data-et-modal="' + id + '"]').forEach(function (m) { if (m !== modal) m.remove(); });
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var titleEl = modal.querySelector('[data-et-modal-title]');
    var bodyEl = modal.querySelector('[data-et-modal-body]');
    var panel = modal.querySelector('.et-modal__panel');
    var tiles = section.querySelectorAll('[data-et-open]');
    var opener = null;

    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    function focusableEls() {
      if (!panel) return [];
      return Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function trapTab(e) {
      var els = focusableEls();
      if (!els.length) { e.preventDefault(); return; }
      var first = els[0];
      var last = els[els.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !panel.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !panel.contains(active)) { e.preventDefault(); first.focus(); }
      }
    }

    function open(tile) {
      /* Announce open/closed state on the control. Without it a screen reader user activates
         the card, the dialog appears visually, and nothing is announced. */
      tile.setAttribute('aria-expanded','true');
      var item = tile.closest('.et-item');
      if (!item) return;
      var t = tile.querySelector('.et-q__title');
      var d = item.querySelector('.et-detail__body');
      if (titleEl) titleEl.textContent = tile.getAttribute('data-modal-title') || (t ? t.textContent : '');
      if (bodyEl) bodyEl.innerHTML = d ? d.innerHTML : '';
      opener = tile;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('et-modal-open');
      document.documentElement.classList.add('f1-et-modal-open');
      var closeBtn = modal.querySelector('[data-et-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      if (opener) opener.setAttribute('aria-expanded','false');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('et-modal-open');
      document.documentElement.classList.remove('f1-et-modal-open');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
      opener = null;
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () { open(tile); });
    });
    modal.addEventListener('click', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.target.closest('[data-et-close]') || !e.target.closest('.et-modal__panel')) close();
    });
    // robust outside-click close: bind directly to the overlay behind the panel
    var overlay = modal.querySelector('.et-modal__overlay');
    if (overlay) overlay.addEventListener('click', function () {
      if (modal.classList.contains('is-open')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { trapTab(e); }
    });
  }
  function initAll(scope) {
    scope = scope || document;
    if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll('[data-et-root]'), initSection);
    if (scope.matches && scope.matches('[data-et-root]')) initSection(scope);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  function init(scope) {
    if (!scope) return;
    var buttons = scope.querySelectorAll('.f1-faq__q');
    buttons.forEach(function (btn) {
      var ans = btn.closest('.f1-faq__item').querySelector('.f1-faq__ans');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var a = b.closest('.f1-faq__item').querySelector('.f1-faq__ans');
          if (a) a.style.maxHeight = null;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
  }
  init(root || document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.f1-intro .video-card').forEach(function (card) {
      if (card.dataset.f1IntroInit) return;
      card.dataset.f1IntroInit = '1';
      var video = card.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.play().catch(function () {});
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(card);
    });
  }
  if (document.readyState !== 'loading') { init(); } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-quote"] && !Shopify.designMode) return;
  try {
    
(function(){
  function isEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}
  function initForm(form){
    if(form.dataset.quoteInit)return;form.dataset.quoteInit='1';
    var dnkEl=form.querySelector('[data-dnk]');
    var ds=form.querySelector('[data-dstart]');
    var dateField=form.querySelector('[data-date-field]');

    function validate(el){
      var f=el.closest('.field');if(!f)return true;
      var ok=true;
      if(el.hasAttribute('required'))ok=el.value.trim()!=='';
      if(ok&&el.type==='email')ok=isEmail(el.value.trim());
      f.classList.toggle('err',!ok);
      return ok;
    }
    form.querySelectorAll('input,select,textarea').forEach(function(el){
      el.addEventListener('blur',function(){validate(el);});
      el.addEventListener('input',function(){if(el.closest('.field')&&el.closest('.field').classList.contains('err'))validate(el);});
    });

    /* ── Globo submission (form 160245, "Rental form 2") ──────────────────────
       The form keeps its own markup and styling; on submit the values go straight
       to Globo's submission API, which is what Globo's own embed posts to. Every
       downstream Globo integration still fires, with no 390KB Globo bundle.

       This replaces the earlier inline delivery script, which posted only AFTER
       the confirmation had already replaced the form. That ordering meant a
       failed POST showed the visitor a thank-you for a lead nobody received.
       Posting first and confirming second is what makes a lost lead visible.

       The element ids below are Globo's, verified against a real accepted
       submission of form 160245. If the form is rebuilt in Globo they change:
       recapture them from Globo.FormBuilder.forms[160245], which the app embed
       inlines on every storefront page. Do not guess.
       2026-08-19: the owner deleted select-1, a second, more restrictive
       "Simulators Required" dropdown, so the exact figure now goes to text-3
       verbatim and no bucketing is needed. */
    /* Hardcoded, NOT a theme setting. This is a section javascript block, which Shopify
       compiles into a static shared asset WITHOUT evaluating Liquid, so a Liquid output
       tag here would ship verbatim and be a syntax error that takes out the whole
       compiled bundle for every section on the site. Never put Liquid in this block, not
       even inside a comment. If the Globo form is ever rebuilt, edit this literal.
       (globo_form_id in the schema drives the separate Globo-embed mode, not this path.) */
    var GLOBO_FORM_ID='160245';
    var GLOBO_URL='https://app.powerfulform.com/api/front/form/'+GLOBO_FORM_ID+'/send';
    /* Globo prints these labels in the notification email. Without _keyLabel the
       email arrives labelled text-1 / phone-1 / textarea instead of Name / Phone / Message. */
    var GLOBO_LABELS={'text-1':'Name','email':'Email','phone-1':'Phone','country-1':'Rental Country','text-2':'City','text-3':'Simulators Required','datetime-1':'Event Start Date','datetime-2':'Event End Date','textarea':'Message (Including dates for the rental period)'};

    function visitorId(){
      try{
        var k='globo-visitor-id',v=localStorage.getItem(k);
        if(!v){
          v=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0;return (c==='x'?r:(r&3|8)).toString(16);});
          localStorage.setItem(k,v);
        }
        return v;
      }catch(e){return '';}
    }
    function fieldVal(n){var el=form.querySelector('[name="'+n+'"]');return el?String(el.value||'').trim():'';}
    function globoPayload(){
      var fd=new FormData();
      var ph=fieldVal('ph'),sims=fieldVal('sims'),start2=fieldVal('dstart'),end2=fieldVal('dend');
      var notSure=!!(dnkEl&&dnkEl.checked);
      var msg=fieldVal('ms'),notes=[];
      if(notSure)notes.push('Dates: not sure yet.');
      else if(start2&&!end2)notes.push('Dates: from '+start2+' (no end date given).');
      /* Message is required on the Globo side, so it is never sent empty. */
      if(!msg)msg='Quote request from the simulator rental page.';
      if(notes.length)msg=msg+'\n\n'+notes.join(' ');
      var cc=fieldVal('ccode');
      fd.append('text-1',fieldVal('name'));
      fd.append('email',fieldVal('em'));
      fd.append('phone-1',ph?((cc?cc+' ':'')+ph):'');
      fd.append('country-1',fieldVal('country'));
      fd.append('text-2',fieldVal('loc'));
      fd.append('text-3',sims);
      fd.append('datetime-1',notSure?'':start2);
      fd.append('datetime-2',notSure?'':end2);
      fd.append('textarea',msg);
      /* Ad attribution. The intake's Add Ad Tracking node scans every submitted string
         field for a JSON blob carrying first/last touch, so cp_attr rides along as an extra
         field. Globo forwards fields it does not know about verbatim (verified 2026-08-19),
         so this needs no hidden field on form 160245. page[href] keeps its query string,
         which is the other half of the attribution: gclid, utm_*, gad_* are read from it. */
      try{
        var cpm=document.cookie.match(/(?:^|;\s*)cp_attr=([^;]+)/);
        if(cpm){var cpv=decodeURIComponent(cpm[1]);if(cpv&&cpv!=='{}')fd.append('cp_attr',cpv);}
      }catch(e){}
      fd.append('page[title]',document.title);
      fd.append('page[href]',window.location.href);
      fd.append('_keyLabel',JSON.stringify(GLOBO_LABELS));
      fd.append('locale',(window.Shopify&&Shopify.locale)||'en');
      try{fd.append('time_zone',Intl.DateTimeFormat().resolvedOptions().timeZone);}catch(e){}
      return fd;
    }

    /* 2-step navigation */
    var steps=form.querySelector('[data-steps]');
    var s1=form.querySelector('.fstep[data-step="1"]');
    var s2=form.querySelector('.fstep[data-step="2"]');
    var stepLabel=form.querySelector('[data-step-label]');
    var segs=form.querySelectorAll('[data-dot]');
    var nextBtn=form.querySelector('[data-step-next]');
    var backBtn=form.querySelector('[data-step-back]');
    form.dataset.step='1';
    function goStep(n){
      if(!steps)return;
      if(s1)s1.hidden=(n!==1);if(s2)s2.hidden=(n!==2);
      segs.forEach(function(d){d.classList.toggle('is-active',parseInt(d.getAttribute('data-dot'),10)<=n);});
      if(stepLabel)stepLabel.innerHTML=(n===1?'Step 1 of 2 &middot; Your details':'Step 2 of 2 &middot; Event details');
      form.dataset.step=String(n);
    }
    /* Abandoned-lead capture. Step 1 is name + email + phone, which is enough to follow up on.
       Fired on a VALID Next click, not on page-exit: beforeunload is unreliable, worst of all on
       mobile, which is exactly where people drop off. n8n waits 15 minutes and only logs the lead
       if no completed submission for that email reached Monday meanwhile, so finishing the form
       normally never produces an abandoned record.
       text/plain keeps this a CORS "simple request": no preflight, nothing to configure, and the
       n8n Guard node parses the string. Fire-and-forget, and wrapped so a failure here can never
       block the visitor from reaching step 2. */
    var PARTIAL_URL='https://coolperformance.app.n8n.cloud/webhook/cp-rental-partial';
    var partialSent=false;
    function sendPartial(){
      if(partialSent)return; partialSent=true;
      try{
        var ph=fieldVal('ph'),cc=fieldVal('ccode');
        var payload=JSON.stringify({
          leadId:visitorId(),
          name:fieldVal('name'),
          email:fieldVal('em'),
          phone:ph?((cc?cc+' ':'')+ph):'',
          href:window.location.href
        });
        if(navigator.sendBeacon&&navigator.sendBeacon(PARTIAL_URL,new Blob([payload],{type:'text/plain'})))return;
        fetch(PARTIAL_URL,{method:'POST',mode:'no-cors',keepalive:true,headers:{'Content-Type':'text/plain'},body:payload});
      }catch(e){}
    }

    if(nextBtn)nextBtn.addEventListener('click',function(){
      var bad=null;
      [].slice.call(s1.querySelectorAll('[required]')).forEach(function(el){if(!validate(el)&&!bad)bad=el;});
      if(bad){bad.focus();return;}
      sendPartial();
      goStep(2);
      if(steps&&steps.scrollIntoView)steps.scrollIntoView({block:'nearest'});
    });
    if(backBtn)backBtn.addEventListener('click',function(){goStep(1);});

    /* Event type is a native <select>; validated by the generic input/select handler above. */

    var submitBtn=form.querySelector('[type="submit"]');
    var sending=false;
    function clearSendError(){var e=form.querySelector('[data-send-error]');if(e)e.remove();}
    function showSendError(){
      clearSendError();
      var d=document.createElement('p');
      d.setAttribute('data-send-error','');
      /* Styled inline so the message never depends on the stylesheet block compiling. */
      d.setAttribute('style','margin:12px 0 0;padding:11px 13px;border:1px solid #e6b0b0;background:#fdf3f3;border-radius:6px;font-size:13px;line-height:1.5;color:#8a2b2b');
      d.innerHTML='Sorry, we could not send that just now. Please try again, or email <a href="mailto:info@coolperformance.com" style="color:inherit;font-weight:600">info@coolperformance.com</a> and we will pick it up right away.';
      var act=form.querySelector('.step2-actions');
      if(act&&act.parentNode)act.parentNode.insertBefore(d,act.nextSibling);else form.appendChild(d);
      d.scrollIntoView({block:'nearest',behavior:'smooth'});
    }

    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(steps&&form.dataset.step==='1'){if(nextBtn)nextBtn.click();return;}
      var reqs=[].slice.call(form.querySelectorAll('[required]'));
      var firstBad=null;
      reqs.forEach(function(el){if(!validate(el)&&!firstBad)firstBad=el;});
      if(dnkEl&&!dnkEl.checked&&ds&&!ds.value){ds.closest('.field').classList.add('err');if(!firstBad)firstBad=form.querySelector('[data-date-btn]')||ds;}
      if(firstBad){var st=firstBad.closest('.fstep');if(steps&&st){goStep(parseInt(st.getAttribute('data-step'),10)||1);}firstBad.focus();return;}
      if(sending)return;
      sending=true;
      var btnHTML=submitBtn?submitBtn.innerHTML:'';
      if(submitBtn){submitBtn.disabled=true;submitBtn.textContent='Sending…';}
      clearSendError();
      fetch(GLOBO_URL,{method:'POST',body:globoPayload(),headers:{'X-Visitor-Id':visitorId()}})
        .then(function(r){return r.json();})
        .then(function(d){
          if(!d||String(d.success)!=='true')throw new Error((d&&d.msg)||'Submission rejected');
          window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'lead_form_submit',form_id:GLOBO_FORM_ID});
          /* class="success" is what the GTM lead trigger (Element Visibility, CSS .success) watches, same as Globo's own thank-you panel. Keep it. */
          form.innerHTML='<div class="success" style="text-align:center;padding:26px 6px 10px"><div style="width:62px;height:62px;border-radius:50%;background:rgba(31,157,87,.15);display:grid;place-items:center;margin:0 auto 16px"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#1f9d57" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg></div><h3 class="subtext-xl" style="font-weight:800;color:#171717">Thanks, we&rsquo;ll be in touch.</h3><p class="text-sm" style="color:#5a6069;margin-top:8px;max-width:36ch;margin-inline:auto">We&rsquo;ll be in touch with a full quote within 24 hours.</p><div style="display:flex;gap:8px;justify-content:center;flex-wrap:wrap;margin-top:14px"><a href="mailto:info@coolperformance.com" style="font-size:13px;font-weight:600;color:#171717;text-decoration:none;border:1px solid #dcdfe3;border-radius:6px;padding:9px 13px">info@coolperformance.com</a><a href="tel:+18773177505" style="font-size:13px;font-weight:600;color:#171717;text-decoration:none;border:1px solid #dcdfe3;border-radius:6px;padding:9px 13px">+1 (877) 317-7505</a></div><div style="text-align:left;background:#f6f7f9;border:1px solid #e6e8ec;border-radius:6px;padding:16px 18px;margin-top:18px"><b style="display:block;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#171717;margin-bottom:10px">Next steps</b><ol style="margin:0;padding-left:18px;color:#3a3f47;font-size:13.5px;line-height:1.7"><li>We&rsquo;ll send your quotation and estimate</li><li>If we need any more details, we&rsquo;ll ask</li><li>Discovery call to build your bespoke event plan</li></ol></div></div>';
        })
        .catch(function(){
          /* Never swallow the enquiry: keep what the visitor typed on screen,
             let them retry, and give them a direct way through. */
          sending=false;
          if(submitBtn){submitBtn.disabled=false;submitBtn.innerHTML=btnHTML;}
          showSendError();
        });
    });

    /* custom event-date range picker */
    var btn=form.querySelector('[data-date-btn]'),pop=form.querySelector('[data-dp]'),grid=form.querySelector('[data-dp-grid]'),
        title=form.querySelector('[data-dp-title]'),txt=form.querySelector('[data-date-text]'),hint=form.querySelector('[data-dp-hint]'),
        de=form.querySelector('[data-dend]');
    if(!btn||!pop)return;
    var MM=['January','February','March','April','May','June','July','August','September','October','November','December'];
    var today=new Date();today.setHours(0,0,0,0);
    var view=new Date(today.getFullYear(),today.getMonth(),1),start=null,end=null;
    function iso(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
    function fmt(d){return d.toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});}
    function fmtS(d){return d.toLocaleDateString('en-GB',{day:'numeric',month:'short'});}
    function sync(){
      ds.value=start?iso(start):'';de.value=end?iso(end):'';
      if(start&&end){var days=Math.round((end-start)/86400000)+1;txt.textContent=(days===1?fmt(end):fmtS(start)+' to '+fmt(end))+' ('+days+' day'+(days===1?'':'s')+')';btn.classList.add('has-val');}
      else if(start){txt.textContent=fmt(start)+' to …';btn.classList.add('has-val');}
      else{txt.textContent='Select your dates';btn.classList.remove('has-val');}
      hint.textContent=(!start||end)?'Pick a start date':'Now pick an end date';
      if(start)dateField.classList.remove('err');
    }
    function render(){
      title.textContent=MM[view.getMonth()]+' '+view.getFullYear();
      var lead=(new Date(view.getFullYear(),view.getMonth(),1).getDay()+6)%7;
      var dim=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();
      var html='';
      for(var i=0;i<lead;i++)html+='<span class="dp-day is-disabled"></span>';
      for(var d=1;d<=dim;d++){
        var cur=new Date(view.getFullYear(),view.getMonth(),d),dis=cur<today;
        var cls='dp-day';
        if(dis)cls+=' is-disabled';
        if(start&&cur.getTime()===start.getTime())cls+=' is-start';
        if(end&&cur.getTime()===end.getTime())cls+=' is-end';
        if(start&&end&&cur>start&&cur<end)cls+=' in-range';
        html+='<button type="button" class="'+cls+'" data-d="'+d+'"'+(dis?' disabled':'')+'>'+d+'</button>';
      }
      grid.innerHTML=html;
    }
    function openPop(){if(btn.disabled)return;pop.hidden=false;btn.setAttribute('aria-expanded','true');render();}
    function closePop(){pop.hidden=true;btn.setAttribute('aria-expanded','false');}
    btn.addEventListener('click',function(){pop.hidden?openPop():closePop();});
    form.querySelector('[data-dp-prev]').addEventListener('click',function(){view=new Date(view.getFullYear(),view.getMonth()-1,1);render();});
    form.querySelector('[data-dp-next]').addEventListener('click',function(){view=new Date(view.getFullYear(),view.getMonth()+1,1);render();});
    form.querySelector('[data-dp-clear]').addEventListener('click',function(){start=end=null;sync();render();});
    grid.addEventListener('click',function(e){
      e.stopPropagation();
      var cell=e.target.closest('.dp-day[data-d]');if(!cell||cell.disabled)return;
      var cur=new Date(view.getFullYear(),view.getMonth(),+cell.dataset.d);
      if(!start||(start&&end)||cur<start){start=cur;end=null;}else{end=cur;}
      sync();render();
      if(start&&end)setTimeout(closePop,160);
    });
    document.addEventListener('click',function(e){if(!pop.hidden&&!pop.contains(e.target)&&!btn.contains(e.target))closePop();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!pop.hidden)closePop();});
    if(dnkEl)dnkEl.addEventListener('change',function(){btn.disabled=dnkEl.checked;if(dnkEl.checked){start=end=null;sync();closePop();dateField.classList.remove('err');}});
  }
  /* Click-to-copy for the contact email. Delegated and bound once, because the contact block
     sits OUTSIDE the form and so is never reached by initForm. Falls back to a hidden textarea
     where the async clipboard API is unavailable: it needs a secure context and permission and
     rejects silently otherwise, which would leave the button looking dead. */
  if(!window.__cpCopyEmailBound){
    window.__cpCopyEmailBound=true;
    document.addEventListener('click',function(e){
      var btn=e.target&&e.target.closest&&e.target.closest('[data-copy-email]');
      if(!btn)return;
      var email=btn.getAttribute('data-copy-email')||'';
      var label=btn.querySelector('[data-copy-label]');
      function done(ok){
        if(!label)return;
        if(btn.__cpT)clearTimeout(btn.__cpT);
        if(!btn.__cpOrig)btn.__cpOrig=label.textContent;
        label.textContent=ok?'Copied to clipboard':btn.__cpOrig;
        if(ok)btn.classList.add('is-copied');
        btn.__cpT=setTimeout(function(){label.textContent=btn.__cpOrig;btn.classList.remove('is-copied');},2000);
      }
      function legacy(){
        try{
          var ta=document.createElement('textarea');
          ta.value=email;ta.setAttribute('readonly','');
          ta.style.cssText='position:fixed;top:0;left:-9999px;opacity:0';
          document.body.appendChild(ta);ta.select();
          var ok=document.execCommand('copy');
          document.body.removeChild(ta);
          done(ok);
        }catch(err){done(false);}
      }
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(email).then(function(){done(true);},legacy);
      }else{legacy();}
    });
  }

  function boot(){document.querySelectorAll('[data-quote-form]').forEach(initForm);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-racing-types"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRt(root){
    if(root.__rt2)return;root.__rt2=true;
    var tabs=[].slice.call(root.querySelectorAll('[data-rt-tab]'));
    var panels=[].slice.call(root.querySelectorAll('[data-rt-panel]'));
    if(!tabs.length)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var auto=reduce?0:(parseFloat(root.getAttribute('data-rt-autoplay'))||0);
    var cur=0,raf=null,t0=0;
    function bar(t){return t.querySelector('.rt2__tab-bar');}
    function clearBars(){tabs.forEach(function(t){var b=bar(t);if(b)b.style.width='0';});}
    function show(i,focusTab){
      cur=i;
      tabs.forEach(function(t,idx){var a=idx===i;t.classList.toggle('is-active',a);t.setAttribute('aria-selected',a?'true':'false');t.setAttribute('tabindex',a?'0':'-1');});
      panels.forEach(function(p,idx){var a=idx===i;p.hidden=!a;p.classList.toggle('is-active',a);});
      clearBars();
      if(focusTab&&tabs[i])tabs[i].focus();
    }
    function stopProg(){if(raf){cancelAnimationFrame(raf);raf=null;}}
    function startProg(){
      stopProg();if(auto<=0)return;
      t0=0;var b=bar(tabs[cur]);
      function tick(now){
        if(!t0)t0=now;
        var p=Math.min(1,(now-t0)/(auto*1000));
        if(b)b.style.width=(p*100)+'%';
        if(p>=1){show((cur+1)%tabs.length);startProg();return;}
        raf=requestAnimationFrame(tick);
      }
      raf=requestAnimationFrame(tick);
    }
    tabs.forEach(function(t,idx){
      t.addEventListener('click',function(){show(idx);if(auto>0)startProg();});
      t.addEventListener('mouseenter',stopProg);
      t.addEventListener('keydown',function(e){
        var k=e.key,n=null;
        if(k==='ArrowRight'||k==='ArrowDown')n=(idx+1)%tabs.length;
        else if(k==='ArrowLeft'||k==='ArrowUp')n=(idx-1+tabs.length)%tabs.length;
        else if(k==='Home')n=0;
        else if(k==='End')n=tabs.length-1;
        else if(k==='Enter'||k===' '){e.preventDefault();show(idx);if(auto>0)startProg();return;}
        if(n!==null){e.preventDefault();stopProg();show(n,true);if(auto>0)startProg();}
      });
    });
    root.addEventListener('mouseleave',function(){if(auto>0)startProg();});
    show(0);
    if(auto>0){
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)startProg();else stopProg();});},{threshold:.3});
        io.observe(root);
      }else{startProg();}
    }
  }
  function run(root){(root||document).querySelectorAll('[data-rt]').forEach(initRt);}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',function(){run();});}
  document.addEventListener('shopify:section:load',function(e){run(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-series-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root||document).querySelectorAll('[data-scarousel]').forEach(function(sc){
      if(sc.__init)return; sc.__init=true;
      var track=sc.querySelector('[data-scarousel-track]');
      if(!track)return;
      var prev=sc.querySelector('[data-scarousel-prev]');
      var next=sc.querySelector('[data-scarousel-next]');
      function step(){var s=track.querySelector('.f1-scarousel__slide');return s?s.getBoundingClientRect().width+20:track.clientWidth*0.7;}
      function go(dir){track.scrollBy({left:dir*step(),behavior:'smooth'});}
      function updateArrows(){
        if(!prev||!next)return;
        var max=track.scrollWidth-track.clientWidth-2;
        prev.toggleAttribute('disabled',track.scrollLeft<=2);
        next.toggleAttribute('disabled',track.scrollLeft>=max);
      }
      if(prev)prev.addEventListener('click',function(){go(-1);});
      if(next)next.addEventListener('click',function(){go(1);});
      track.addEventListener('scroll',function(){window.requestAnimationFrame(updateArrows);},{passive:true});
      updateArrows();

      // drag to scroll (pointer)
      var down=false,startX=0,startLeft=0,moved=false;
      track.addEventListener('pointerdown',function(e){if(e.pointerType==='mouse'&&e.button!==0)return;down=true;moved=false;startX=e.clientX;startLeft=track.scrollLeft;});
      track.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4){moved=true;sc.setAttribute('data-grabbing','');}track.scrollLeft=startLeft-dx;});
      function end(){if(!down)return;down=false;sc.removeAttribute('data-grabbing');}
      track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('pointerleave',end);
      track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);

      // autoplay
      var ap=parseFloat(sc.getAttribute('data-autoplay'));
      if(ap>0){
        var timer=null;
        function loop(){
          var max=track.scrollWidth-track.clientWidth-2;
          if(track.scrollLeft>=max){track.scrollTo({left:0,behavior:'smooth'});}else{go(1);}
        }
        function play(){stop();timer=setInterval(loop,ap*1000);}
        function stop(){if(timer){clearInterval(timer);timer=null;}}
        sc.addEventListener('pointerenter',stop);sc.addEventListener('pointerleave',play);
        track.addEventListener('focusin',stop);track.addEventListener('focusout',play);
        if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)play();
      }
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init();});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-services"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.__f1svcBound) return;
    root.__f1svcBound = true;
    var modal = root.querySelector('[data-svc-modal]');
    if (!modal) return;
    // Portal the modal to <body> so filtering #MainContent blurs the page behind it while the modal stays sharp.
    document.querySelectorAll('body > [data-svc-modal]').forEach(function (m) { if (m !== modal) m.remove(); });
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var lastTrigger = null;

    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    function focusableEls() {
      return Array.prototype.filter.call(
        modal.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    // Give the modal an accessible name from its heading.
    var titleEl = modal.querySelector('[data-svc-title]');
    if (titleEl) {
      if (!titleEl.id) { titleEl.id = 'svc-modal-title-' + (root.id || Math.random().toString(36).slice(2)); }
      modal.setAttribute('aria-labelledby', titleEl.id);
    }

    function openModal(card) {
      /* Announce open/closed state on the control. Without it a screen reader user activates
         the card, the dialog appears visually, and nothing is announced. */
      lastTrigger = card;
      card.setAttribute('aria-expanded','true');
      var img = modal.querySelector('[data-svc-img]');
      if (img) { img.src = card.getAttribute('data-svc-image') || ''; img.alt = card.getAttribute('data-svc-title') || ''; }
      if (titleEl) titleEl.textContent = card.getAttribute('data-svc-title') || '';
      var textEl = modal.querySelector('[data-svc-text]');
      if (textEl) {
        var detailId = card.getAttribute('data-svc-detail');
        var detailEl = detailId ? document.getElementById(detailId) : null;
        textEl.innerHTML = detailEl ? detailEl.innerHTML : '';
      }
      var badge = modal.querySelector('.svc-modal__badge[data-svc-badge]');
      if (badge) {
        badge.hidden = card.getAttribute('data-svc-badge') !== 'true';
        badge.textContent = card.getAttribute('data-svc-badge-text') || 'Popular Add On';
      }
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('f1svc-modal-open');
      // Move focus into the modal (close button) so keyboard/AT users land inside it.
      var closeBtn = modal.querySelector('.svc-modal__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeModal() {
      if (lastTrigger) lastTrigger.setAttribute('aria-expanded','false');
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('f1svc-modal-open');
      // Return focus to the card that opened the modal.
      if (lastTrigger && typeof lastTrigger.focus === 'function') { lastTrigger.focus({ preventScroll: true }); }
      lastTrigger = null;
    }

    function trapTab(e) {
      var els = focusableEls();
      if (!els.length) { e.preventDefault(); return; }
      var first = els[0];
      var last = els[els.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !modal.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !modal.contains(active)) { e.preventDefault(); first.focus(); }
      }
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-svc-card]');
      if (card && root.contains(card)) { openModal(card); return; }
      if (e.target.closest('[data-close]')) { closeModal(); }
    });
    // robust outside-click close: bind directly to the backdrop (and any [data-close]) inside the modal
    modal.addEventListener('click', function (e) {
      if (!modal.classList.contains('open')) return;
      if (e.target.closest('[data-close]') || e.target === modal.querySelector('.svc-modal__backdrop')) { closeModal(); }
    });

    // Div cards carry button semantics (role="button"), so activate on Enter/Space like a native button.
    root.addEventListener('keydown', function (e) {
      var card = e.target.closest('[data-svc-card]');
      if (!card || !root.contains(card)) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(card); }
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') { trapTab(e); }
    });
  }

  function initAll() {
    document.querySelectorAll('.f1-services').forEach(initSection);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.f1-services');
    if (sec) initSection(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(bar){
    if(!bar||bar.dataset.f1StickyInit)return;
    bar.dataset.f1StickyInit='1';
    var pastScroll=false,hideZone=false,quoteVis=false;
    var ticking=false,docH=0,winH=0;
    function measure(){docH=document.documentElement.scrollHeight;winH=window.innerHeight;}
    function update(){bar.classList.toggle('show',pastScroll&&!hideZone&&!quoteVis);}
    function compute(){
      var y=window.pageYOffset||document.documentElement.scrollTop||0;
      pastScroll=y>600;
      var bottom=y+winH;
      docH=document.documentElement.scrollHeight; /* re-read every frame: the cached value goes stale as reveals/lazy content grow the page, which made the hide-zone swallow everything below the quote section */
      hideZone=(docH-bottom)<200;
      update();
    }
    function onScroll(){
      if(ticking)return;
      ticking=true;
      window.requestAnimationFrame(function(){compute();ticking=false;});
    }
    function onResize(){measure();onScroll();}
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onResize,{passive:true});
    measure();
    compute();
    var quote=document.querySelector('#quote, .f1-quote');
    if(quote&&'IntersectionObserver'in window){
      new IntersectionObserver(function(e){quoteVis=e[0].isIntersecting;update();},{threshold:.18}).observe(quote);
    }
  }
  function initAll(root){
    (root||document).querySelectorAll('[data-f1-sticky]').forEach(initBar);
  }
  initAll();
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-why-us"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var loaded = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var video = e.target;
        if (e.isIntersecting) {
          if (!loaded.has(video)) {
            loaded.add(video);
            var source = video.querySelector('source[data-src]');
            if (source && !source.src) { source.src = source.dataset.src; video.load(); }
          }
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.f1-why-us__video').forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
